function setColProductVariant(variants, itmQty, handle)
{
    var isValid = false;
    var qty = $(".qty-" + handle).val();
    qty = parseInt(qty) + parseInt(itmQty);
    for (var variant in variants) {
        if (variants.hasOwnProperty(variant) && !isValid) {
            if (variants[0] == "1 - 50 BAG" && variants[1] == "51 - 100 BAG" && variants[2].title == "101 - 1000 BAG"){
                if ((qty >= 1) && (qty <= 50))
                {
                    $(".id-" + handle).val("{{variant.id}}");
                    isValid = true;
                }
                else if ((qty >= 51) && (qty <= 100))
                {
                    $(".id-" + handle).val("{{variant.id}}");
                    isValid = true;
                }
                else if ((qty >= 101) && (qty <= 1000))
                {
                    $(".id-" + handle).val("{{variant.id}}");
                    isValid = true;
                }
            }
            else if (variants[0] == "1 - 10 BOX" && variants[1] == "11 - 20 BOX" && variants[2].title == "21 - 1000 BOX"){
                if ((qty >= 1) && (qty <= 10))
                {
                    $(".id-" + handle).val("{{variant.id}}");
                    isValid = true;
                }
                else if ((qty >= 11) && (qty <= 20))
                {
                    $(".id-" + handle).val("{{variant.id}}");
                    isValid = true;
                }
                else if ((qty >= 21) && (qty <= 1000))
                {
                    $(".id-" + handle).val("{{variant.id}}");
                    isValid = true;
                }
            }
            else if (variants[0] == "1 - 25 BOX" && variants[1] == "26 - 50 BOX" && variants[2].title == "51 - 1000 BOX"){
                if ((qty >= 1) && (qty <= 25))
                {
                    $(".id-" + handle).val("{{variant.id}}");
                    isValid = true;
                }
                else if ((qty >= 26) && (qty <= 50))
                {
                    $(".id-" + handle).val("{{variant.id}}");
                    isValid = true;
                }
                else if ((qty >= 51) && (qty <= 1000))
                {
                    $(".id-" + handle).val("{{variant.id}}");
                    isValid = true;
                }
            }
            else if (variants[0] == "1 - 60 BOX" && variants[1] == "61 - 120 BOX" && variants[2].title == "121 - 10000 BOX"){
                if ((qty >= 1) && (qty <= 60))
                {
                    $(".id-" + handle).val("{{variant.id}}");
                    isValid = true;
                }
                else if ((qty >= 61) && (qty <= 120))
                {
                    $(".id-" + handle).val("{{variant.id}}");
                    isValid = true;
                }
                else if ((qty >= 121) && (qty <= 10000))
                {
                    $(".id-" + handle).val("{{variant.id}}");
                    isValid = true;
                }
            }
            else if (variants[0] == "1 - 9 BOX" && variants[1] == "10 - 19 BOX" && variants[2].title == "20 - 10000 BOX"){
                if ((qty >= 1) && (qty <= 9))
                {
                    $(".id-" + handle).val("{{variant.id}}");
                    isValid = true;
                }
                else if ((qty >= 10) && (qty <= 19))
                {
                    $(".id-" + handle).val("{{variant.id}}");
                    isValid = true;
                }
                else if ((qty >= 20) && (qty <= 10000))
                {
                    $(".id-" + handle).val("{{variant.id}}");
                    isValid = true;
                }
            }
            else if (variants[0] == "1 - 50 BOX" && variants[1] == "51 - 100 BOX" && variants[2].title == "101 - 1000 BOX"){
                if ((qty >= 1) && (qty <= 50))
                {
                    $(".id-" + handle).val("{{variant.id}}");
                    isValid = true;
                }
                else if ((qty >= 51) && (qty <= 100))
                {
                    $(".id-" + handle).val("{{variant.id}}");
                    isValid = true;
                }
                else if ((qty >= 101) && (qty <= 1000))
                {
                    $(".id-" + handle).val("{{variant.id}}");
                    isValid = true;
                }
            }
            else if (variants[0] == "1 - 20 BOX" && variants[1] == "21 - 40 BOX" && variants[2].title == "41 - 1000 BOX"){
                if ((qty >= 1) && (qty <= 20))
                {
                    $(".id-" + handle).val("{{variant.id}}");
                    isValid = true;
                }
                else if ((qty >= 21) && (qty <= 40))
                {
                    $(".id-" + handle).val("{{variant.id}}");
                    isValid = true;
                }
                else if ((qty >= 41) && (qty <= 1000))
                {
                    $(".id-" + handle).val("{{variant.id}}");
                    isValid = true;
                }
            }
            else if (variants[0] == "1 - 100 BOX" && variants[1] == "101 - 200 BOX" && variants[2].title == "201 - 1000 BOX"){
                if ((qty >= 1) && (qty <= 100))
                {
                    $(".id-" + handle).val("{{variant.id}}");
                    isValid = true;
                }
                else if ((qty >= 101) && (qty <= 200))
                {
                    $(".id-" + handle).val("{{variant.id}}");
                    isValid = true;
                }
                else if ((qty >= 201) && (qty <= 1000))
                {
                    $(".id-" + handle).val("{{variant.id}}");
                    isValid = true;
                }
            }
            else if (variants[0] == "1 - 50 BOX" && variants[1] == "51 - 100 BOX" && variants[2].title == "101 - 150 BOX"){
                if ((qty >= 1) && (qty <= 50))
                {
                    $(".id-" + handle).val("{{variant.id}}");
                    isValid = true;
                }
                else if ((qty >= 51) && (qty <= 100))
                {
                    $(".id-" + handle).val("{{variant.id}}");
                    isValid = true;
                }
                else if ((qty >= 101) && (qty <= 150))
                {
                    $(".id-" + handle).val("{{variant.id}}");
                    isValid = true;
                }
            }
            else if (variants[0] == "1 - 100 BOX" && variants[1] == "101 - 200 BOX" && variants[2].title == "201 - 10000 BOX"){
                if ((qty >= 1) && (qty <= 100))
                {
                    $(".id-" + handle).val("{{variant.id}}");
                    isValid = true;
                }
                else if ((qty >= 101) && (qty <= 200))
                {
                    $(".id-" + handle).val("{{variant.id}}");
                    isValid = true;
                }
                else if ((qty >= 201) && (qty <= 10000))
                {
                    $(".id-" + handle).val("{{variant.id}}");
                    isValid = true;
                }
            }
		    else if (variants[0] == "BOX" && variants[1] == "25 BOX+" && variants[2].title == "125 BOX+"){
                if ((qty >= 1) && (qty <= 24))
                {
                    $(".id-" + handle).val("{{variant.id}}");
                    isValid = true;
                }
                else if ((qty >= 25) && (qty <= 124))
                {
                    $(".id-" + handle).val("{{variant.id}}");
                    isValid = true;
                }
                else if ((qty >= 125) && (qty <= 10000))
                {
                    $(".id-" + handle).val("{{variant.id}}");
                    isValid = true;
                }
            }
        }
    }
    if (isValid)
    {
        if(itmQty > 0)
        {
            $(".qty-" + handle).val(qty);
            $(".remove-" + handle).submit();
        }
        setTimeout("$('.frm-" + handle + "').submit()", 2000);
        return true;
    }
    else
    {
        alert("Please enter a valid quantity.");
        return false;
    }
}